// Navigation constants for sidebar
import {
  AppstoreOutlined,
  BankOutlined,
  MoneyCollectOutlined,
  UserOutlined,
  WalletOutlined,
  TrophyOutlined,
  SettingOutlined,
  BarChartOutlined,
  AuditOutlined,
} from '@ant-design/icons';

export interface NavigationItem {
  id: string;
  key: string;
  icon: any;
  label: string;
  translationKey: string;
  color?: string;
  superAdminOnly?: boolean;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'dashboard',
    key: '/user-panel/dashboard',
    icon: AppstoreOutlined,
    label: 'Dashboard',
    translationKey: 'navBar.dashboard',
    color: '#3b82f6', // Blue
  },
  {
    id: 'analytics',
    key: '/user-panel/analytics',
    icon: BarChartOutlined,
    label: 'Analytics',
    translationKey: 'navBar.analytics',
    color: '#8b5cf6', // Purple
    superAdminOnly: true,
  },
  {
    id: 'audit',
    key: '/user-panel/audit',
    icon: AuditOutlined,
    label: 'Audit',
    translationKey: 'navBar.audit',
    color: '#06b6d4', // Cyan
    superAdminOnly: true,
  },
  {
    id: 'requests',
    key: '/user-panel/requests',
    icon: BankOutlined,
    label: 'Requests',
    translationKey: 'navBar.requests',
    color: '#10b981', // Green
  },
  {
    id: 'operations',
    key: '/user-panel/operations',
    icon: MoneyCollectOutlined,
    label: 'Operations',
    translationKey: 'navBar.operations',
    color: '#f59e0b', // Amber
  },
  {
    id: 'users',
    key: '/user-panel/users',
    icon: UserOutlined,
    label: 'Users',
    translationKey: 'navBar.users',
    color: '#ec4899', // Pink
  },
  {
    id: 'wallet',
    key: '/user-panel/wallet',
    icon: WalletOutlined,
    label: 'Wallet',
    translationKey: 'navBar.wallet',
    color: '#14b8a6', // Teal
  },
  {
    id: 'gamification',
    key: '/user-panel/gamification',
    icon: TrophyOutlined,
    label: 'Gamification',
    translationKey: 'navBar.gamification',
    color: '#f97316', // Orange
  },
  {
    id: 'settings',
    key: '/user-panel/settings',
    icon: SettingOutlined,
    label: 'Settings',
    translationKey: 'navBar.settings',
    color: '#6b7280', // Gray
  },
];

export const VIEW_MODES = ['All Admins', 'Admin 1', 'Admin 2', 'Admin 3'];
